/* ================================================================
   HomePage — 클론 사이트별 랜딩 변형 디스패처.

   10개 클론은 서로 "다른 회사"처럼 보여야 하므로 랜딩페이지 자체를
   테마 번호(=사이트 번호)별 독립 컴포넌트로 분기한다.
   - 테마 1~10 → src/pages/home/Home01~Home10 (레이아웃·카피·팔레트 독립)
   - 그 외(원본/dev) → home/HomeDefault (기존 에디토리얼 랜딩)
   변형은 React.lazy 청크로 분리되어 각 사이트는 자기 것만 로드한다.
   dev에서는 /?theme=N 으로 변형을 미리볼 수 있다(shared.themeNumber).
   ================================================================ */
import React, { Suspense, lazy } from "react";
import { themeNumber } from "./home/shared";

const HomeDefault = lazy(() => import("./home/HomeDefault"));
const VARIANTS = {
  1: lazy(() => import("./home/Home01")),
  2: lazy(() => import("./home/Home02")),
  3: lazy(() => import("./home/Home03")),
  4: lazy(() => import("./home/Home04")),
  5: lazy(() => import("./home/Home05")),
  6: lazy(() => import("./home/Home06")),
  7: lazy(() => import("./home/Home07")),
  8: lazy(() => import("./home/Home08")),
  9: lazy(() => import("./home/Home09")),
  10: lazy(() => import("./home/Home10")),
};

export default function HomePage() {
  const Variant = VARIANTS[themeNumber()] || HomeDefault;
  return (
    <Suspense fallback={null}>
      <Variant />
    </Suspense>
  );
}
